import { Customer } from '../types';

export const customers: Customer[] = [
  {
    id: 'interk',
    name: 'InterK',
    logo: '/assets/InterK.png',
    url: 'https://inter-k.com/',
  },
  {
    id: 'pne',
    name: 'PNE',
    logo: '/assets/PNEIT.png',
    url: 'https://pneit.net/',
  },
  {
    id: 'wd',
    name: 'Workday',
    logo: '/assets/wd.png',
    url: 'https://www.workday.com/',
  },
  {
    id: 'smilegate',
    name: 'Smile Gate',
    logo: '/assets/Smilegate.svg',
    url: 'https://smilegatevn.com/',
  },
  {
    id: 'fois',
    name: 'Fois ICT Pro',
    logo: '/assets/Fois.png',
    url: 'https://foisictpro.com/',
  },
  {
    id: 'cj',
    name: 'CJ OLIVENETWORKS VINA ',
    logo: '/assets/CJ.svg',
    url: 'https://cjvietnam.vn/',
  }
]; 